import { BookingDetails } from "modules/BookingCommon/common/interfaces"
import { GetTimeRequestResponse, PaymentSystemType } from "utils/interfaces"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { SessionTypePartial } from "modules/Booking/common/interfaces"
import { DepositInfoResponse } from "modules/Booking/common/utils"

export function paymentPageProps(
    sessionType: SessionTypePartial,
    timeRequestResponse?: GetTimeRequestResponse,
    bookingDetails?: BookingDetails,
    depositResponse?: DepositInfoResponse
) {
    if (sessionType === SESSION_TYPE.DEFAULT) {
        return {
            paymentSystem: bookingDetails?.payment_system,
            tryAgain:
                bookingDetails?.payment_system === PaymentSystemType.CLOUDPAYMENTS ||
                bookingDetails?.payment_system === PaymentSystemType.STRIPE ||
                bookingDetails?.payment_system === PaymentSystemType.GAZPROMPAY,
            price: bookingDetails?.price,
            priceUsd: bookingDetails?.price_usd,
            bookingId: bookingDetails?.booking_id,
            orderId: bookingDetails?.order_id,
            orderHash: bookingDetails?.order_hash,
        }
    }
    if (sessionType === SESSION_TYPE.TIME_REQUEST) {
        return {
            paymentSystem: timeRequestResponse?.payment_system,
            tryAgain:
                timeRequestResponse?.payment_system === PaymentSystemType.CLOUDPAYMENTS ||
                timeRequestResponse?.payment_system === PaymentSystemType.STRIPE ||
                timeRequestResponse?.payment_system === PaymentSystemType.GAZPROMPAY,
            price: timeRequestResponse?.price,
            priceUsd: timeRequestResponse?.price_usd,
            bookingId: timeRequestResponse?.order_id,
            orderId: timeRequestResponse?.order_id,
            orderHash: timeRequestResponse?.order_hash,
        }
    }
    if (sessionType === SESSION_TYPE.DEPOSIT) {
        return {
            paymentSystem: depositResponse?.payment_system,
            tryAgain:
                depositResponse?.payment_system === PaymentSystemType.CLOUDPAYMENTS ||
                depositResponse?.payment_system === PaymentSystemType.STRIPE ||
                depositResponse?.payment_system === PaymentSystemType.GAZPROMPAY,
            price: depositResponse?.price,
            priceUsd: depositResponse?.price_usd,
            bookingId: depositResponse?.order_id,
            orderId: depositResponse?.order_id,
            orderHash: depositResponse?.order_hash,
        }
    }
}
